<template>
  <section >
    <v-card flat>
      <v-layout row>
          <v-flex xs10  sm10  md6 lg6 xl6 class="header-table">
            <v-flex offset-xs1 offset-sm1 offset-md1 offset-lg1 offset-xl1 >
              <p class="title">Listado de Usuarios</p>
            </v-flex>
          </v-flex>
          <v-flex xs10  sm10  md6 lg6 xl6  class="header-table">
            <v-flex offset-xs1 offset-sm5 offset-md7 offset-lg8 offset-xl8 >
              <v-btn color="primary"  offset-xs8 offset-sm8 offset-md8 offset-lg8 offset-xl8  @click="go('maintainer')"><v-icon>arrow_back</v-icon>Volver</v-btn>
            </v-flex>
          </v-flex>
        </v-layout>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-text-field
          append-icon="search"
          label="Buscador"
          single-line
          hide-details
          v-model="search"
        ></v-text-field>
      </v-card-title>
      <v-data-table
          v-bind:headers="headers"
          v-bind:items="usuarios"
          v-bind:search="search"
          rows-per-page-text = "Filas por Pagina"
          no-data-text="No hay Usuarios Creados"
        >
        <template slot="items" slot-scope="props">
          <td class="text-xs-center">{{ props.item.nombre }} {{ props.item.apellido }}</td>
          <td class="text-xs-center">{{ props.item.email }}</td>
          <td class="text-xs-center">{{ props.item.rut }}</td>
          
          <!-- <td v-if="props.item.user_account_type === 1" class="text-xs-center" >Estudiante</td>
          <td v-else-if="props.item.user_account_type === 2" class="text-xs-center" >Profesor</td>
          <td v-else-if="props.item.user_account_type === 7" class="text-xs-center" >Administrador</td>
          <td v-else class="text-xs-center" >-</td> -->
          <td v-if="props.item.created_at === null" class="text-xs-center">No hay fecha</td>
           <td v-else class="text-xs-center" >{{ props.item.created_at }}</td>
          <td class="text-xs-center" v-if="props.item.user_account_type === 1">
             <v-select
              v-model="props.item.user_account_type"
              :items="tiposUsuarios"
              item-text="nombre"
              persistent-hint
              bottom3
              :label="tiposUsuarios[0].nombre"
              @input="cambioid(props.item.user_account_type, props.item.id)"
            ></v-select></td>
            <td class="text-xs-center" v-else-if="props.item.user_account_type === 2">
             <v-select
              v-model="props.item.user_account_type"
              :items="tiposUsuarios"
              item-text="nombre"
              persistent-hint
              bottom3
              :label="tiposUsuarios[1].nombre"
              @input="cambioid(props.item.user_account_type, props.item.id)"
            ></v-select></td>
            <td class="text-xs-center" v-else-if="props.item.user_account_type === 7">
             <v-select
              v-model="props.item.user_account_type"
              :items="tiposUsuarios"
              item-text="nombre"
              persistent-hint
              bottom3
              :label="tiposUsuarios[2].nombre"
              @input="cambioid(props.item.user_account_type, props.item.id)"
            ></v-select></td>
            <td class="text-xs-center" v-else>
             <v-select
              v-model="props.item.user_account_type"
              :items="tiposUsuarios"
              item-text="nombre"
              persistent-hint
              bottom3
              label="-"
              @input="cambioid(props.item.user_account_type, props.item.id)"
            ></v-select></td>
            

          <td class="text-xs-center">
            <v-btn flat icon color="red darken-2" @click="showDialogDeleteElement(props.item.id)">
              <v-icon>delete</v-icon>
            </v-btn>
          </td>
        </template>
        <template slot="pageText" slot-scope="{ pageStart, pageStop }">
          Desde {{ pageStart }} a {{ pageStop }}
        </template>
      </v-data-table>
    </v-card>






<v-dialog v-model="dialogDeleteElement"  max-width="500px" >
  <v-card class=" ma-0">
      <v-card-title class="balck--text center headline">¿Estas seguro que lo deseas <span class="white--text">.</span><span class="red--text"> Eliminar</span>?</v-card-title>
    <v-form  >
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn  color="red" outline @click.native="dialogDeleteElement = false" >Cancelar</v-btn>
        <v-btn class="white--text" color="red"  @click="deleteUser()" >Eliminar</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</v-dialog>

  <v-snackbar
      :timeout="timeout"
      :color="colorSnackbar"
      v-model="snackbar"
    >
    <v-icon dark>check_circle</v-icon>
      {{ textSnackbar }}
      <v-btn dark flat @click.native="snackbar = false">X</v-btn>
  </v-snackbar>


  </section>
</template>

<script>
import { changeTipoUsuarioService } from '@/services/Usuario/ChangeTipoUsuario'
import { userService } from '@/services/User.service'

export default {
  data () {
    return {
      usuarios: [],
      usuario: {},
      currentInstitucion: {},
      tmp: '',
      search: '',
      pagination: {},
      snackbar: false,
      colorSnackbar: '',
      timeout: 6000,
      textSnackbar: '',
      tipoUsuario: null,
      idseleccion: 0,
      usuarioCargado: false,
      enviado: {
        tipoUsuario: ''
      },
      tiposUsuarios: [
        {nombre: 'Estudiante', id: '1'},
        {nombre: 'Profesor', id: '2'},
        {nombre: 'Administrador', id: '7'}
      ],
      headers: [
        { text: 'Nombre', align: 'center', value: 'nombre' },
        { text: 'Email', align: 'center', value: 'email' },
        { text: 'Rut', align: 'center', value: 'rut' },
        // { text: 'Tipo Usuario', align: 'center', value: 'tipousuarios' },
        { text: 'Fecha Creacion', align: 'center', value: 'fecha' },
        { text: 'Cambiar Tipo', align: 'center', value: 'cambiar' },
        { text: 'Eliminar', align: 'center', value: 'eliminar' }
      ],
      elementDelete: 0,
      dialogDeleteElement: false
    }
  },
  methods: {
    loadUsuarios () {
      let vm = this
      userService.query().then(data => {
        vm.usuarios = data.body
      })
    },
    verLeccion (id) {
      this.$router.push({name: 'showLesson', params: {id: id}})
    },
    deleteUser () {
      let vm = this
      userService.destroy(vm.elementDelete).then(data => {
        vm.dialogDeleteElement = false
        vm.mensajeToast('success', true, 'Usuario eliminada con exito')
        vm.instituciones = data.body
      }, response => {
        vm.mensajeToast('error', true, 'Error al eliminar Usuario')
        vm.dialogDeleteElement = false
      })
    },
    cambiarTipoUsuario (tipoUsuario) {
      this.enviado = tipoUsuario
      changeTipoUsuarioService.update(this.idseleccion, this.enviado).then(data => {
        this.mensajeToast('success', true, 'Cambio Exitoso')
        this.usuarios = data.body
      }, response => {
        this.mensajeToast('error', true, 'Error')
      })
    },
    cambioid (idTipo, idUser) {
      var tipoNuevoUsuario = {
        tipoUsuario: ''
      }
      tipoNuevoUsuario.tipoUsuario = idTipo.id
      if (idTipo.id !== undefined) {
        changeTipoUsuarioService.update(idUser, tipoNuevoUsuario).then(data => {
          this.mensajeToast('success', true, 'Cambio Exitoso')
          this.usuarioCargado = true
          this.loadUsuarios()
        }, response => {
          if (this.usuarioCargado === false) {
            this.mensajeToast('error', true, 'Error al cambiar tipo de usuario')
          }
        })
      }
      this.usuarioCargado = false
    },

    showDialogDeleteElement (id) {
      let vm = this
      vm.elementDelete = id
      vm.dialogDeleteElement = true
    },
    mensajeToast (color, snack, texto) {
      let vm = this
      vm.colorSnackbar = color
      vm.snackbar = snack
      vm.textSnackbar = texto
    },
    go (ruta) {
      this.$router.push({name: ruta})
    }
  },
  mounted () {
    let vm = this
    vm.loadUsuarios()
  }
}
</script>

<style scoped>
.header-table{
  min-height: 75px;
  padding-top: 15px;
  background-color: white;
}
</style>




// WEBPACK FOOTER //
// src/components/Usuario/GetAllUsuarios.vue